import React from "react";
import PropTypes from "prop-types";
import {Button, Tabs} from "antd";
import DashboardFullRow from "@web/components/DashboardFullRow";
import CollectionFetch from "@web/ui/containers/CollectionFetch";
import AppListingsList from "@web/components/AppListingsList";
import {UserContext, WindowContext} from '@web/hooks/context';
// import {PlusIcon} from "@web/assets/icons";
import {useLocation} from "wouter";
import AppsList from "@web/components/AppsList";
import AppStoreTagsData from "@web/ui/containers/AppStoreTagsData";
import contentActions from "@web/redux/content/actions";
import {useDispatch} from "react-redux";

AppStore.propTypes = {
  list: PropTypes.array,
  activeKey: PropTypes.string,
};

function AppStore(props) {
  const dispatch = useDispatch();
  const [userId, h] = React.useContext(UserContext);
  const [isMobile,, height] = React.useContext(WindowContext);
  const [activeKey, setActiveKey] = React.useState(props.activeKey || "published");
  const [, setLocation] = useLocation();

  React.useEffect(() => {
    dispatch(contentActions.fetch({
      path: [h, "app-store"].join("/"),
      body: {
        searchOptions: {
          tags: [activeKey],
        },
      },
      method: "POST",
    }));
  }, [activeKey]);

  return <DashboardFullRow>
    <section
      className="is-desktop"
      style={{backgroundColor: "#0e161f"}}
    >
      <div style={{height: 20}}></div>
      <Tabs
        destroyInactiveTabPane
        centered
        activeKey={activeKey}
        onChange={setActiveKey}
        renderTabBar={(props, DefaultTabBar) => isMobile ? null : <DefaultTabBar {...props} />}
        tabBarExtraContent={<Button className="icon-btn green-color" shape="round" onClick={() => setLocation("/apps/create")} style={{position: "relative", left: -20}}>Create</Button>}
        // style={{marginRight: 20}}
        items={[{
          key: "installed",
          label: <label className="font-lgs">Installed</label>,
          children: <CollectionFetch key="apps" collectionId="apps" component={AppsList} height={isMobile ? height - 30 : height - 80} />,
        },{
          key: "published",
          label: <label className="font-lgs">Discover</label>,
          children: <AppStoreTagsData tag={"published"} component={AppListingsList} height={isMobile ? height - 30 : height - 80} />,
        },{
          key: "core",
          label: <label className="font-lgs">Core</label>,
          children: <AppStoreTagsData tag={"core"} component={AppListingsList} height={isMobile ? height - 30 : height - 80} />,
        },{
          key: "integrations",
          label: <label className="font-lgs">Integrations</label>,
          children: <AppStoreTagsData tag={"integrations"} component={AppListingsList} height={isMobile ? height - 30 : height - 80} />,
          // children: <CollectionFetch key="store-core" collectionId="store" searchOptions={{tags: ["connect"]}} height={isMobile ? height - 30 : height - 100} component={AppListingsList} />,
        },{
          key: "work",
          label: <label className="font-lgs">Work</label>,
          children: <AppStoreTagsData tag={"work"} component={AppListingsList} height={isMobile ? height - 30 : height - 80} />,
          // children: <CollectionFetch key="store-work" collectionId="store" searchOptions={{tags: ["work"]}} height={isMobile ? height - 30 : height - 100} component={AppListingsList} />,
        },
        //   {
        //   key: "play",
        //   label: "Play",
        // },
        //   {
        //   key: "utilities",
        //   label: "Utilities",
        // },
        //   {
        //   key: "business",
        //   label: "Business",
        // },
          {
          key: "social",
          label: "Social",
            children: <AppStoreTagsData tag={"social"} component={AppListingsList} height={isMobile ? height - 30 : height - 80} />,
            // children: <CollectionFetch key="store-social" collectionId="store" searchOptions={{tags: ["social"]}} height={isMobile ? height - 30 : height - 100} component={AppListingsList} />,
        }, {
          key: "news",
          label: "News",
            children: <AppStoreTagsData tag={"news"} component={AppListingsList} height={isMobile ? height - 30 : height - 80} />,
            // children: <CollectionFetch key="store-news" collectionId="store" searchOptions={{tags: ["news"]}} height={isMobile ? height - 30 : height - 100} component={AppListingsList} />,
        },{
          key: "shopping",
          label: "Shopping",
            children: <AppStoreTagsData tag={"shopping"} component={AppListingsList} height={isMobile ? height - 30 : height - 80}  />,
            // children: <CollectionFetch key="store-shopping" collectionId="store" searchOptions={{tags: ["shopping"]}} height={isMobile ? height - 30 : height - 100} component={AppListingsList} />,
        },
        //   {
        //   key: "finance",
        //   label: "Finance",
        // },
        //   {
        //   key: "travel",
        //   label: "Travel",
        // },{
        //   key: "education",
        //   label: "Education",
        // },{
        //   key: "food",
        //   label: "Food",
        // },{
        //   key: "photo",
        //   label: "Photo",
        // },{
        //   key: "art",
        //   label: "Art",
        // },{
        //   key: "productivity",
        //   label: "Productivity",
        // },{
        //   key: "sports",
        //   label: "Sports",
        // },{
        //   key: "health",
        //   label: "Health",
        // },{
        //   key: "fitness",
        //   label: "Fitness",
        // },
        ]}
      />
    </section>
  </DashboardFullRow>
}

export default AppStore;
